/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Talk_TrainerInputs */

const en_us2_plan_build_talk_trainer = /** @type {(inputs: Plan_Build_Talk_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build it with the trainer`)
};

const pt_br2_plan_build_talk_trainer = /** @type {(inputs: Plan_Build_Talk_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montar conversando com o personal`)
};

const es_419_plan_build_talk_trainer = /** @type {(inputs: Plan_Build_Talk_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armarlo con el entrenador`)
};

const pt_pt2_plan_build_talk_trainer = /** @type {(inputs: Plan_Build_Talk_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montar a conversar com o treinador`)
};

const fr_fr2_plan_build_talk_trainer = /** @type {(inputs: Plan_Build_Talk_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le construire avec le coach`)
};

const de_de2_plan_build_talk_trainer = /** @type {(inputs: Plan_Build_Talk_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit dem Coach bauen`)
};

const it_it2_plan_build_talk_trainer = /** @type {(inputs: Plan_Build_Talk_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creala con il coach`)
};

/**
* | output |
* | --- |
* | "Build it with the trainer" |
*
* @param {Plan_Build_Talk_TrainerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_talk_trainer = /** @type {((inputs?: Plan_Build_Talk_TrainerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Talk_TrainerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_talk_trainer(inputs)
	if (locale === "es-419") return es_419_plan_build_talk_trainer(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_talk_trainer(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_talk_trainer(inputs)
	if (locale === "de-DE") return de_de2_plan_build_talk_trainer(inputs)
	if (locale === "it-IT") return it_it2_plan_build_talk_trainer(inputs)
	return en_us2_plan_build_talk_trainer(inputs)
});
export { plan_build_talk_trainer as "plan-build.talk_trainer" }